<template>
  <v-container id="kidProfile" fluid>
    <v-row>
      <v-col md="12" cols="12">
        <v-card flat tile>
          <v-card-title>
            <v-row align="center">
              <v-col cols="12" md="6">
                <div class="heading-h3">Profile</div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle>
            <p>
              Complete or update your child's information.
            </p>
          </v-card-subtitle>
          <v-card-text>
            <!-- Basic Section -->
            <v-list-item class="px-0">
              <div class="body-heading-medium">Basic</div>
              <v-btn v-if="!isEditingGeneralInfo" @click="toggleEditingGeneralInfo" icon class="ma-1">
                <v-icon size="16">fas fa-edit</v-icon>
              </v-btn>
            </v-list-item>
            <v-row>
              <v-col v-if="!isEditingGeneralInfo" cols="12" md="12">
                <!-- Kid Avatar -->
                <v-row justify="center" align="center">
                  <v-col cols="12" md="1">
                    <v-avatar v-if="kid.avatar" slot="icon">
                      <img alt="Avatar" v-bind:src="kid.avatar" />
                    </v-avatar>
                    <v-avatar v-else slot="icon" color="grey lighten-2">
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="11">
                    <div>Child's Avatar</div>
                    <UpdateAvatarModal :userId="kid.id" userType="child" />
                  </v-col>
                </v-row>

                <!-- Kid Name -->
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Child's Name:</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ kid.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- Kid Birthday -->
                <v-list-item v-if="kid.birthday" two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Child's Birthday:</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ kid.birthday }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- Kid Email -->
                <v-list-item two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Child's Email:</v-list-item-title>
                    <v-list-item-subtitle>{{ kid.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- Kid Phone -->
                <v-list-item two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Child's Phone:</v-list-item-title>
                    <v-list-item-subtitle>{{ kid.phone }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <!-- Edit General Info Form -->
              <v-col v-else cols="12" md="12">
                <v-form :class="{ 'half-width': !isMobile }" v-model="isGeneralInfoFormValid" ref="generalInfoForm" @submit.prevent="updateGeneralInfo">
                  <!-- Name -->
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field label="First Name" name="firstName" outlined dense type="text" required :rules="firstNameRules" v-model="newKidProfile.first_name" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="Last Name" name="lastName" outlined dense type="text" required :rules="lastNameRules" v-model="newKidProfile.last_name" />
                    </v-col>
                  </v-row>

                  <!-- Birthday -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-menu ref="menu" v-model="isBirthdayPickerOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="newKidProfile.birthday" label="Birthday (optional)" outlined dense readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" v-model="newKidProfile.birthday" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @change="selectBirthday"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <!-- Email -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field label="Email" name="email" outlined dense type="text" required :rules="emailRules" v-model="newKidProfile.email" />
                    </v-col>
                  </v-row>
                  <!-- Phone -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <VuePhoneNumberInput v-model="newKidProfile.phone" default-country-code="CA" :only-countries="['CA']" color="#354093" error-color="#ff4d4f" no-example />
                    </v-col>
                  </v-row>
                  <v-btn color="secondary" type="submit" :disabled="!isGeneralInfoFormValid">
                    Save
                  </v-btn>

                  <v-btn text @click="cancel">Cancel</v-btn>
                </v-form>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <!-- Password Section -->
            <v-list-item class="px-0">
              <p class="body-heading-medium">Password</p>
            </v-list-item>
            <v-row>
              <v-col v-if="!isEditingPassword" cols="12" md="12">
                <v-btn @click="toggleEditingPassword" color="secondary">Update Password</v-btn>
              </v-col>
              <!-- Edit Password Form -->
              <v-col v-else cols="12" md="12">
                <v-form :class="{ 'half-width': !isMobile }" v-model="isPasswordFormValid" ref="passowordForm" @submit.prevent="updatePassoword">
                  <!-- Old Password -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field label="Old password" name="old_password" outlined dense type="password" required :rules="passwordRules" v-model="newKidPassword.oldPassword" />
                    </v-col>
                  </v-row>
                  <!-- New Password -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field label="New password" name="password" outlined dense type="password" required :rules="passwordRules" v-model="newKidPassword.password" />
                    </v-col>
                  </v-row>
                  <!-- Confirm New Password -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field label="Confirm new password" name="confirm_password" outlined dense type="password" required :rules="confirmPasswordRules" v-model="newKidPassword.passwordConfirmation" />
                    </v-col>
                  </v-row>
                  <v-btn color="secondary" type="submit" :disabled="!isPasswordFormValid">
                    Save
                  </v-btn>

                  <v-btn text @click="cancel">Cancel</v-btn>
                </v-form>
              </v-col>
            </v-row>

            <v-divider class="my-4" />

            <!-- Delete Account Section -->
            <v-row>
              <v-col cols="12" md="12">
                <v-list-item class="px-0">
                  <p class="body-heading-medium">Delete Account</p>
                </v-list-item>
                <v-list-item class="px-0">
                  <DeleteAccountModal :accountId="kid.id" userType="child" />
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DeleteAccountModal from "@/components/DeleteAccountModal";
  import UpdateAvatarModal from "@/components/UpdateAvatarModal";
  import VuePhoneNumberInput from "vue-phone-number-input";

  export default {
    name: "KidProfile",

    data() {
      return {
        kid: {},
        isEditingGeneralInfo: false,
        isEditingPassword: false,
        newKidProfile: {},
        newKidPassword: {},
        isBirthdayPickerOpen: false,
        firstNameRules: [(v) => !!v || "Fist Name is required"],
        lastNameRules: [(v) => !!v || "Last name is required"],
        phoneRules: [
          (v) => !!v || "Phone number is required",
          (v) => {
            if (/^[0-9\-\()]*$/.test(v)) {
              return true;
            }
            return "Only numbers or '()' or '-' are allowed";
          },
          (v) => (v && v.length >= 10) || "Phone number must be at least 10 numbers",
        ],
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
        passwordRules: [(v) => !!v || "Password is required"],
        confirmPasswordRules: [(v) => !!v || "Password is required", (v) => v === this.newKidPassword.password || "Password do not match"],
        termsRules: [(v) => !!v || "You must agree to continue"],
        birthdayRules: [(v) => !!v || "Birthday is required"],
        isGeneralInfoFormValid: false,
        isPasswordFormValid: false,
      };
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },

    watch: {
      isBirthdayPickerOpen(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      },
    },

    methods: {
      toggleEditingGeneralInfo() {
        this.isEditingPassword = false;
        this.newKidProfile = this.$formatter.extend(this.kid);
        this.isEditingGeneralInfo = true;
      },

      toggleEditingPassword() {
        this.isEditingGeneralInfo = false;
        this.isEditingPassword = true;
      },

      selectBirthday(date) {
        this.$refs.menu.save(date);
      },

      updateGeneralInfo() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .put(`/children/${this.$route.params.id}`, this.newKidProfile)
          .then((response) => {
            this.kid = response.data.child;
            this.isEditingGeneralInfo = false;
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Could not update kid's profile, please try again later",
              type: "error",
            });
            this.isEditingGeneralInfo = false;
            this.$store.commit("setLoadingStatus", false);
          });
      },

      updatePassoword() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .put(`/children/${this.$route.params.id}/password/reset`, {
            old_password: this.newKidPassword.oldPassword,
            new_password: this.newKidPassword.password,
            new_password_confirmation: this.newKidPassword.passwordConfirmation,
          })
          .then((response) => {
            this.isEditingPassword = false;
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Could not update kid's password, please try again later",
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },

      cancel() {
        this.newKidProfile = {};
        this.newKidPassword = {};
        this.isEditingGeneralInfo = false;
        this.isEditingPassword = false;
      },
    },

    components: { DeleteAccountModal, UpdateAvatarModal, VuePhoneNumberInput },

    created() {
      this.$http
        .get(`/children/${this.$route.params.id}`)
        .then((response) => {
          //TODO move this into Vuex module
          this.kid = response.data.child;
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: "Could not retrieve kid's profile, please try again later",
            type: "error",
          });
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidProfile.vue